/* @flow strict */

import * as React from 'react';
import { QuestionDisplayType } from '../../../constants';
import Dropdown from './components/dropdown';
import CheckboxDropdown from './components/checkboxDropdown';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import './registrationInfoForm.scss';

type PropsType = {
  questions: [],
  handleChange: () => void
};
const QuestionsForm = (props: PropsType): React.Element<'div'> => {
  const { questions, handleChange } = props;

  const renderInput = (question: {}): React.Element<'input'> => {
    return (
      <input
        type="text"
        name={question.id}
        className='sparxo-checkout-registration-info-form_input'
        title="This field is required."
        onChange={(e: {}): void => (
          handleChange({ id: e.target.name, value: e.target.value, isRequired: question.is_required })
        )}
      />
    );
  };
  const renderDropdownList = (question: {}): React.Element<'select'> => {
    return (
      <Dropdown
        options={question.options}
        onChange={(e: {}): void => (
          handleChange({ id: e.target.name, value: e.target.value, isRequired: question.is_required })
        )}
      />
    );
  };
  const renderCheckbox = (question: {}): React.Element<'select'> => {
    return (
      <CheckboxDropdown
        options={question.options}
        onChange={(): void => null}
      />
    );
  };

  const renderQuestion = (question: {}): React.Element<'select'> => {
    switch (question.display_type) {
      case QuestionDisplayType.TextBox:
        return renderInput(question);
      case QuestionDisplayType.DropdownList:
        return renderDropdownList(question);
      case QuestionDisplayType.Checkbox:
        return renderCheckbox(question);
      default:
        break;
    }
  };


  return (
    <div className='sparxo-checkout-registration-info-form_container'>
      {
        questions.map((question: {}, index: number): React.Element<'div'> => (
          <div key={index} className='sparxo-checkout-registration-info-form_inputContainer'>
            <div className='sparxo-checkout-registration-info-form_inputCaption'>{question.text}</div>
            <div className='sparxo-checkout-registration-info-form_inputTooltipContainer'>

              {renderQuestion(question)}

              {question.help_text &&
                <span>
                  <CTooltip>
                    <CTooltipLabel standart>?</CTooltipLabel>
                    <CTooltipText>
                      <div className='sparxo-checkout-registration-info-form_tooltip'>
                        {question.help_text}
                      </div>
                    </CTooltipText>
                  </CTooltip>
                </span>
              }

            </div>
          </div>
        ))
      }
    </div>
  );
};

export default QuestionsForm;
